import { Check } from "lucide-react";
import { brl } from "@/lib/api";

const ORDER = ["R", "I", "D", "P"];

export const ServicePicker = ({ items, groups, selected, onToggle, disabled }) => (
  <div className="space-y-8" data-testid="service-picker">
    {ORDER.map((g) => (
      <div key={g}>
        <p className="eyebrow mb-3">{groups?.[g]}</p>
        <div className="grid gap-2 md:grid-cols-2">
          {items.filter((i) => i.group === g).map((it) => {
            const on = selected.includes(it.key);
            return (
              <button type="button" key={it.key} disabled={disabled} onClick={() => onToggle(it.key)} data-testid={`picker-item-${it.key}`}
                className={`flex items-center gap-3 border px-3 py-2.5 text-left transition-colors duration-200 disabled:cursor-not-allowed disabled:opacity-60 ${on ? "border-red-600 bg-red-950/30" : "border-[#273248] bg-[#0B0F17] hover:border-slate-500"}`}>
                <span className={`flex h-5 w-5 shrink-0 items-center justify-center border ${on ? "border-red-600 bg-red-600" : "border-slate-600"}`}>
                  {on && <Check className="h-3.5 w-3.5 text-white" />}
                </span>
                <span className="w-9 shrink-0 font-mono text-xs font-bold text-red-400">{it.code}</span>
                <span className="flex-1 text-sm text-slate-200">{it.nome}</span>
                <span className="shrink-0 font-mono text-xs text-slate-400">{brl(it.preco)}</span>
              </button>
            );
          })}
        </div>
      </div>
    ))}
  </div>
);
